export default class WorkstationController {
  /**
   * 分页查询工作站列表
   * @param {Object} sender - 发送器对象
   * @param {Object} params - 请求参数
   * @param {Object} axiosOption - axios配置
   * @param {Object} httpOption - HTTP配置
   * @returns {Promise} - 请求结果
   */
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/workstation/list', 'post', params, axiosOption, httpOption);
  }

  /**
   * 查看工作站详情
   * @param {Object} sender - 发送器对象
   * @param {Object} params - 请求参数
   * @param {Object} axiosOption - axios配置
   * @param {Object} httpOption - HTTP配置
   * @returns {Promise} - 请求结果
   */
  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/workstation/view', 'get', params, axiosOption, httpOption);
  }

  /**
   * 添加工作站
   * @param {Object} sender - 发送器对象
   * @param {Object} params - 请求参数
   * @param {Object} axiosOption - axios配置
   * @param {Object} httpOption - HTTP配置
   * @returns {Promise} - 请求结果
   */
  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/workstation/add', 'post', params, axiosOption, httpOption);
  }

  /**
   * 更新工作站
   * @param {Object} sender - 发送器对象
   * @param {Object} params - 请求参数
   * @param {Object} axiosOption - axios配置
   * @param {Object} httpOption - HTTP配置
   * @returns {Promise} - 请求结果
   */
  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/workstation/update', 'post', params, axiosOption, httpOption);
  }

  /**
   * 删除工作站
   * @param {Object} sender - 发送器对象
   * @param {Object} params - 请求参数
   * @param {Object} axiosOption - axios配置
   * @param {Object} httpOption - HTTP配置
   * @returns {Promise} - 请求结果
   */
  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/workstation/delete', 'post', params, axiosOption, httpOption);
  }

  /**
   * 导入工作站数据
   * @param {Object} sender - 发送器对象
   * @param {Object} params - 请求参数（包含FormData）
   * @param {Object} axiosOption - axios配置
   * @param {Object} httpOption - HTTP配置
   * @returns {Promise} - 请求结果
   */
  static importData (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/workstation/import', 'post', params, axiosOption, httpOption);
  }
}
